import {
  TableCellForAuthRequired,
  TableCellWithBadge,
  TableCellWithColoredText,
} from "../../../../../data-model/tableCells";
import {
  PatientOrdersForTable,
  PatientOrdersTableData,
} from "../../../../../data-model/tablesData";
import _ from "lodash";
import {
  BadgeColor,
  BadgeTextColor,
  ColoredText,
} from "../../../../../enums/coloredText";
import { PatientOrdersTableColumnKeys } from "../../../../../enums/tableColumnKeys";
import {
  TableCellType,
  TableHeader,
} from "../../../../../components/custom-table/table";
import { InfoIcon } from "../../../../../svg/info-icon";

export const PatientOrdersTableColumns: TableHeader[] = [
  {
    label: "Authorization ID",
    key: PatientOrdersTableColumnKeys.AUTH_ID,
    order: 1,
    width: 12,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Submission Date",
    key: PatientOrdersTableColumnKeys.SUBMISSION_DATE,
    order: 2,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Submitted By",
    key: PatientOrdersTableColumnKeys.SUBMITTED_BY,
    order: 3,
    width: 17,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Plan Name",
    key: PatientOrdersTableColumnKeys.PLAN_NAME,
    order: 4,
    width: 17,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Location",
    key: PatientOrdersTableColumnKeys.LOCATION,
    order: 5,
    width: 8,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Priority",
    key: PatientOrdersTableColumnKeys.PRIORITY,
    order: 6,
    width: 8,
    sortable: true,
    type: TableCellType.COLORED_TEXT,
  },
  {
    label: "Date of Service",
    key: PatientOrdersTableColumnKeys.DATE_OF_SERVICE,
    order: 7,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Auth Required",
    key: PatientOrdersTableColumnKeys.AUTH_REQUIRED,
    order: 8,
    width: 10,
    sortable: false,
    type: TableCellType.INFO,
  },
  {
    label: "Status",
    key: PatientOrdersTableColumnKeys.STATUS,
    order: 9,
    width: 8,
    sortable: true,
    type: TableCellType.BADGE,
  },
];

export function generateUiDataForPatientsOrderTable(
  orders: PatientOrdersForTable[],
): PatientOrdersTableData[] {
  return orders.map((order) => {
    const authId: string = order.authId || "N/A";
    const submissionDate: string = order.submissionDate || "N/A";
    const submittedBy: string = order.submittedBy || "N/A";
    const planName: string = order.planName || "N/A";
    const location: string = _.capitalize(order.location) || "N/A";
    const priority: TableCellWithColoredText | string = order.priority
      ? {
          text: _.capitalize(order.priority),
          color: ColoredText[_.capitalize(order.priority)],
        }
      : "N/A";
    const dateOfService: string = order.dateOfService || "N/A";
    const authRequired: TableCellForAuthRequired = {
      count: order.authRequired,
      cptCodesWithStatus: order.cptCodesWithPaStatus
        ? order.cptCodesWithPaStatus.map((cptCodeWithPaStatus) => {
            return {
              text: cptCodeWithPaStatus.text,
              value: cptCodeWithPaStatus.value,
              image: InfoIcon,
            };
          })
        : null,
    };
    const status: TableCellWithBadge | string = order.status
      ? {
          text: _.capitalize(order.status),
          color: BadgeTextColor[_.capitalize(order.status)],
          bgColor: BadgeColor[_.capitalize(order.status)],
        }
      : "N/A";

    const docId: string = order.docId || "N/A";
    return {
      [PatientOrdersTableColumnKeys.AUTH_ID]: authId,
      [PatientOrdersTableColumnKeys.SUBMISSION_DATE]: submissionDate,
      [PatientOrdersTableColumnKeys.SUBMITTED_BY]: submittedBy,
      [PatientOrdersTableColumnKeys.PLAN_NAME]: planName,
      [PatientOrdersTableColumnKeys.LOCATION]: location,
      [PatientOrdersTableColumnKeys.PRIORITY]: priority,
      [PatientOrdersTableColumnKeys.DATE_OF_SERVICE]: dateOfService,
      [PatientOrdersTableColumnKeys.AUTH_REQUIRED]: authRequired,
      [PatientOrdersTableColumnKeys.STATUS]: status,
      [PatientOrdersTableColumnKeys.DOC_ID]: docId,
    };
  });
}
